/**
 * useBlock Hook (Web)
 * Thin wrapper around shared useBlock
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import { type UseBlockResult, useBlock as useBlockShared } from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseBlockResult };

export function useBlock(targetUserId: string): UseBlockResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useBlockShared({ httpClient, targetUserId, isAuthenticated });
}
